import React from 'react';
import { useLocation } from 'react-router-dom';
import { SEO } from 'components/SEO';

import 'assets/css/bootstrap.min.css';
import 'assets/css/style.css';
import 'assets/css/responsive.css';
import logo from 'assets/images/logo-mark.png';
import iconEmail from 'assets/images/icon-email.svg';
import iconRightArrow from 'assets/images/icon-arrow-right.svg';
import logoWhite from 'assets/images/logo-white.png';
import iconMap from 'assets/images/icon-map.svg';

interface IProps {
  children: React.ReactNode
}

const PublicLayout = ({ children }: IProps) => {
  const location = useLocation();

  return (
    <>
      <SEO pathname={location.pathname} />
      <header id="header-section">
        <div className="header-shell">
          <nav className="navbar navbar-expand-lg header-pill">
            <a className="navbar-brand p-0" href="/"><img className="default-transition" src={logo} alt="Studio Cassolato" /></a>
            <button className="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#sitemenu" aria-controls="sitemenu" aria-expanded="false" aria-label="Apri menu">
              <span className="navbar-toggler-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                </svg>
              </span>
            </button>
            <div className="collapse navbar-collapse justify-content-end" id="sitemenu">
              <ul className="navbar-nav">
                <li className="nav-item"><a className="nav-link" href="/company">Chi Siamo</a></li>
                <li className="nav-item"><a className="nav-link" href="/pim">PIM</a></li>
                <li className="nav-item"><a className="nav-link" href="/solutions">Soluzioni software</a></li>

                <li className="nav-item d-block d-lg-none d-xl-none"><a className="nav-link" href="/contacts">Contattaci</a></li>
                <li className="nav-item d-block d-lg-none d-xl-none"><a className="nav-link" href="/jobs">Lavora con noi</a></li>
              </ul>
            </div>
            <div className="header-right">
              <a href="/contacts" className="header-icon"><img src={iconEmail} alt="Contattaci" /></a>
              <a href="/jobs" className="default-btn btn-pop default-transition">Lavora con noi<img src={iconRightArrow} alt="" /></a>
            </div>
          </nav>
        </div>
      </header>

      {children}
      <div className="cta-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 cta-left">
              <div className="section-title"><p>Contattaci</p></div>
              <p className="cta-lead">Cerchi un partner affidabile in grado di guidare la tua azienda nel processo di innovazione digitale?</p>
              <a href="/contacts" className="default-btn btn-ghost default-transition">Contattaci<img src={iconRightArrow} alt="" /></a>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-lg-4 footer-box">
              <a href="/" className="footer-logo"><img src={logoWhite} alt="Studio Cassolato" /></a>
              <div className="footer-social">
                <a href="https://www.facebook.com/studiocassolato" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32.169" height="32.169" viewBox="0 0 32.169 32.169">
                    <g className="icons8-facebook orange-icon" transform="translate(1.5 1.5)">
                      <path className="Path_3" data-name="Path 3" d="M28.52,34.126A14.6,14.6,0,0,1,7.077,15.6" transform="translate(-5.5 -7.638)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                      <path className="Path_4" data-name="Path 4" d="M13.9,7.865A14.341,14.341,0,0,1,21.862,5.5,14.6,14.6,0,0,1,36.447,20.085a14.362,14.362,0,0,1-1.971,7.332" transform="translate(-7.278 -5.5)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                      <path className="Path_5" data-name="Path 5" d="M16.788,25.614h3.153V36.02a11.944,11.944,0,0,0,4.73,0V25.614H27.51a.838.838,0,0,0,.788-.71l.315-2.365a1.485,1.485,0,0,0-.158-.631.9.9,0,0,0-.631-.237H24.672V18.913a1.581,1.581,0,0,1,1.577-1.577h1.577a.745.745,0,0,0,.788-.788v-2.68a.778.778,0,0,0-.71-.788c-.079,0-1.183-.079-2.6-.079-3.469,0-5.361,2.05-5.361,5.834v2.838H16.788A.745.745,0,0,0,16,22.46v2.365A.745.745,0,0,0,16.788,25.614Z" transform="translate(-7.722 -7.087)" fill="" />
                    </g>
                  </svg>
                </a>
                <a href="https://it.linkedin.com/company/studio-cassolato-srls" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29.016" height="29.016" viewBox="0 0 29.016 29.016">
                    <g className="icons8-linkedin orange-icon" transform="translate(1.5 1.5)">
                      <path className="Path_22" data-name="Path 22" d="M33.516,30.261v3.784A3.163,3.163,0,0,1,30.362,37.2H10.653A3.163,3.163,0,0,1,7.5,34.045V24.9" transform="translate(-7.5 -11.183)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                      <path className="Path_23" data-name="Path 23" d="M7.5,16.724v-6.07A3.163,3.163,0,0,1,10.653,7.5H30.362a3.163,3.163,0,0,1,3.153,3.153V21.69" transform="translate(-7.5 -7.5)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
                      <ellipse className="Ellipse_5" data-name="Ellipse 5" cx="1.971" cy="1.971" rx="1.971" ry="1.971" transform="translate(4.336 4.336)" fill="" />
                      <path className="Path_24" data-name="Path 24" d="M16.153,31.825H13.788A.745.745,0,0,1,13,31.037V20.788A.745.745,0,0,1,13.788,20h2.365a.745.745,0,0,1,.788.788V31.037A.745.745,0,0,1,16.153,31.825Z" transform="translate(-8.664 -10.146)" fill="" />
                      <path className="Path_25" data-name="Path 25" d="M27.1,20a5.023,5.023,0,0,0-3.153,1.183v-.394A.745.745,0,0,0,23.153,20H20.788a.745.745,0,0,0-.788.788V31.037a.745.745,0,0,0,.788.788h2.365a.745.745,0,0,0,.788-.788V25.124a1.971,1.971,0,1,1,3.942,0v5.913a.745.745,0,0,0,.788.788h2.365a.745.745,0,0,0,.788-.788V24.73A4.744,4.744,0,0,0,27.1,20Z" transform="translate(-10.146 -10.146)" fill="" />
                    </g>
                  </svg>
                </a>
              </div>
              <br />
              <a href="https://www.iubenda.com/privacy-policy/44628708" className="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a>
            </div>
            <div className="col-12 col-sm-6 col-lg-4 footer-box flist-box">
              <p className="footer-title">Link</p>
              <p><a href="/">Home</a></p>
              <p><a href={'/company'}>Chi siamo</a></p>
              <p><a href={'/pim'}>PIM</a></p>
              <p><a href={'/solutions'}>Soluzioni software</a></p>
              <p><a href={'/contacts'}>Contattaci</a></p>
              <p><a href={'/jobs'}>Lavora con noi</a></p>


            </div>
            <div className="col-12 col-sm-6 col-lg-4 footer-box flist-box flist-details">
              <p className="footer-title">Studio Cassolato Srls</p>
              <p className="footer-subtitle">Sede Operativa</p>
              <p><img src={iconMap} alt="" />Piazza della Serenissima, 40 <br />c/o Coffice Business Center<br />31033 Castelfranco Veneto (TV)</p>
              <p className="footer-subtitle">Sede Legale</p>
              <p><img src={iconMap} alt="" />Viale Cairoli 27/F<br /> 31100 Treviso (TV)</p>


            </div>
          </div>
          <p className="copyright-text text-center">&copy; {new Date().getFullYear()} Studio Cassolato Srls unipersonale, Partita IVA e Codice Fiscale IT 04715500262</p>
        </div>
      </footer>

    </>
  );
}

export default PublicLayout;
